'use strict';

angular.module('cloudBillingLegacyFrontend').directive('eaContentCentered', function() {
  return {
    restrict: 'C',
    template: '<div style="display: table; height: 100%; width: 100%;"><div style="display: table-cell; vertical-align: middle;"><ng-transclude></ng-transclude></div></div>',
    transclude: true
  };
});
